module.exports = __webpack_public_path__ + "images/bcdb7351eff795dac049c87e729293a9-illu_box.svg";